module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(3).b51e60b3.png";